import { DeviceApi, DeviceLinkClaimsApi } from "@generated/n3-backend-api";
import { inject, injectable } from "inversify";
import { makeObservable } from "mobx";
import ApiService from "@/src/application/services/api-service";
import DeviceService, {
  type DeviceLinkClaimRequest,
  type PropertyProfile,
} from "@/src/application/services/device-service";

@injectable()
export default class DeviceServiceImpl extends DeviceService {
  constructor(
    @inject(DeviceApi) private readonly deviceApi: DeviceApi,
    @inject(DeviceLinkClaimsApi) private readonly deviceLinkClaimsApi: DeviceLinkClaimsApi,
    @inject(ApiService) private readonly apiService: ApiService
  ) {
    super();
    makeObservable(this);
  }

  public async fetchAllDevices() {
    const response = await this.deviceApi.getDevices();
    return response.data.devices;
  }

  public async fetchDeviceById(id: number) {
    const response = await this.deviceApi.getDevice(id);
    return response.data;
  }

  public async fetchDeviceLinkSuggestions() {
    const response = await this.deviceLinkClaimsApi.getSuggestions();
    return response.data;
  }

  public async claimDeviceLinks(request: DeviceLinkClaimRequest) {
    const response = await this.deviceLinkClaimsApi.claimDevices(request);
    return response.data;
  }

  public async updateDevicePropertyProfile(id: number, propertyProfile: PropertyProfile) {
    await this.apiService
      .getAxiosInstance()
      .put(`/api/v1/devices/${id}/property-profile`, { propertyProfile });
  }
}
